<!--
  Renders the Resource - Blog app route
-->
<template>
  <!-- Blog Post Type -->
  <div class="row">
    <div data-e2e-id="cis-resource-blog" class="col-lg-12 col-md-12 col-sm-12 template-content">
      <!-- Main Content -->
      <div class="col-lg-9 col-md-9 col-sm-12 template-main-content">
        <resource-heading
          v-bind:title="routeData.fields.resourceTitle"
          v-bind:subTitle="routeData.fields.resourceSubtitle"
        />
        <resource-content v-bind:field="routeData.fields.resourceContent" />

        <!-- CTA -->
        <cta v-bind:field="routeData.fields.cta" />

        <p class="cis-resource-disclaimer">
          As of June 23, 2025, the MS-ISAC has introduced a fee-based membership. Any potential
          reference to no-cost MS-ISAC services no longer applies.
        </p>

        <!-- Placeholder - Sign Up Modal -->
        <sc-placeholder name="jss-sign-up-modal" :rendering="rendering" />
      </div>
      <!-- Right Rail -->
      <div class="col-lg-3 col-md-3 col-sm-12 template-sidebar" :class="{ addShadow: isContent }">
        <!-- Placeholder - Right Rail Top -->
        <sc-placeholder name="jss-right-rail-top" :rendering="rendering" />

        <!-- CTA -->
        <cta v-bind:field="routeData.fields.cta" />

        <!-- Related Resources -->
        <related-resource v-bind:fields="routeData.fields" />

        <!-- Placeholder - Right Rail -->
        <sc-placeholder name="jss-right-rail" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import ResourceContent from './CIS-ResourceContent.vue';
import ResourceHeading from './CIS-ResourceHeading.vue';
import Cta from './CIS-ResourceCTA.vue';
import RelatedResource from './CIS-ResourceRelatedResources.vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Blog',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ResourceContent,
    ResourceHeading,
    Cta,
    RelatedResource,
    ScPlaceholder: Placeholder
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.template-content {
  .cis-resource-disclaimer {
    font-style: italic;
    margin: 20px 0 40px 0 !important;
  }

  &:deep() {
    h3 {
      background-color: transparent !important;
    }

    p {
      background-color: transparent !important;
    }

    ul {
      li {
        background-color: transparent !important;
      }
    }
  }

  .resource-content {
    h2:first-child {
      margin-bottom: 1rem;
    }

    &:deep() {
      h2:first-child {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
